/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { TwChip, TwIcon, TwRow } from '@tw/tw-components-rn';

import { CommonStore } from '@/app/core/store/common/common-store';
import { Dimensions } from 'react-native';
import { MIN_OPEN_PACKAGE_AMOUNT } from '@/app/core/store/common/type';
import { MaterialIcons } from '@expo/vector-icons';
import { ProductTypeEnumValue } from '@tw/clvip-api-gen';
import { TwTheme } from '@tw/tw-runtime-rn';
import { styles } from './../styles';
import { useStoreState } from '@tw/tw-runtime-react';

export const MallFilters = (props) => {
  const commonStore = CommonStore.getInstance();
  const [store] = useState(commonStore);

  const productType = useStoreState(store, (state) => state.productType);
  const openPackageAmount = useStoreState(store, (state) => state.openPackageAmount) ?? 0;
  const isContainOpenPackage = useStoreState(store, (state) => state.isContainOpenPackage);
  const amountDiff = MIN_OPEN_PACKAGE_AMOUNT - openPackageAmount;

  console.log('MallFilters', isContainOpenPackage, openPackageAmount, amountDiff);

  return (
    <TwRow justifyContent={productType === ProductTypeEnumValue.open_package ? 'space-between' : 'flex-end'}>
      {productType === ProductTypeEnumValue.open_package && (
        <View style={{ flex: 1, justifyContent: 'center' }}>
          {isContainOpenPackage && amountDiff > 0 ? (
            <TouchableOpacity
              onPress={() => {
                store.setAddToCartPopupVisible(true);
                store.setCartPopUpVisible(false);
                store.getUnderGoods(amountDiff, ProductTypeEnumValue.open_package, 'list');
              }}
            >
              <TwRow style={styles.headerContainer}>
                <TwRow alignItems={'center'} space={1}>
                  <MaterialIcons name="info-outline" size={16} color="#8E8E8E" />
                  {/* TODO: 客户需求前提,只有300 600两个档,商品价格固定 */}
                  <Text style={styles.headerTitle}>零售选购需满500整或1000整</Text>
                </TwRow>
                <TwRow>
                  <Text style={{ color: TwTheme.values.textColors.secondary, fontSize: 12 }}>去加购</Text>
                  <MaterialIcons name={'keyboard-arrow-right'} size={16} color={TwTheme.values.textColors.secondary} />
                </TwRow>
              </TwRow>
            </TouchableOpacity>
          ) : (
            <TwRow alignItems={'center'} space={1}>
              <MaterialIcons name="info-outline" size={16} color="#8E8E8E" />
              <Text style={styles.headerTitle}>零售选购需满500整或1000整</Text>
            </TwRow>
          )}
        </View>
      )}
      <TwChip
        text={'价格'}
        style={{
          backgroundColor: '#FFFFFF'
        }}
        suffix={<TwIcon icon="icon-sort-two" size={12} />}
        onPress={() => {
          store.onSortChange();
        }}
      />
    </TwRow>
  );
};
